<template>
	<main class="flex justify-between items-center rounded-lg" style="border: 1px solid #ccc;">
		<strong class="cursor-pointer px-3 py-1" @click.prevent="doIncrementDecrement('-')">-</strong>
		<slot name="content">
			<strong class="px-3 py-1">{{ num }}</strong>
		</slot>
		<strong class="cursor-pointer px-3 py-1" @click.prevent="doIncrementDecrement('+')">+</strong>
	</main>
</template>
<script>
	export default {
		data: () => ({
			num: 1,
			ops: '-'
		}),
		methods: {
			doIncrementDecrement(ops) {
				this.ops = ops
				if(ops == '-') {
					this.num = this.num < 2 ? 1 : this.num-1
				}
				else {
					this.num++
				}
			}
		},
		watch: {
			num(val) {
				this.$emit('count', {val, ops: this.ops})
			}
		}
	}
</script>